import React from 'react'

export const ListHeader = () => {
  return (
    <thead>
      <tr>
        <th style={{ width: '10px' }} />
        <th style={{ width: '30%' }}>Keys</th>
        <th style={{ width: '30%' }}>Value</th>
        <th style={{ width: '30%' }}>Unit</th>
        <th style={{ width: '10px' }} />
      </tr>
    </thead>
  )
}
